import config from 'config'
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu'
import React from 'react'
import "./Eresources.css"

export const Eresources = () => {
  return (
        <>
        <RoutingMenu activeScreen="eResources" />
    <div className=''>

        <iframe
            src={`${config.RootUrl}/faculty/library/eResource/eResource.php?isIframe=true`}
            className="iframe col-md-12"
        >
        </iframe>
    </div>
    </>
  )
}
